import {
  CardBodyProps,
  CardFooterProps,
  CardHeaderProps,
  CardProps
} from './types';

export function styleCard(props: CardProps) {
  const mc = 'Card';
  const cls = {
    main: [mc]
  };
  if (props.rounded) {
    cls.main.push(`${mc}--rounded`);
  }
  if (props.raised) {
    cls.main.push(`${mc}--raised`);
  }
  if (props.seperated) {
    cls.main.push(`${mc}--seperated`);
  }
  if (props.padding) {
    cls.main.push(`${mc}--padding-${props.padding}`);
  }
  if (props.bgColor) {
    cls.main.push(`${mc}--color-${props.bgColor}`);
  }
  if (props.outlined) {
    cls.main.push(`${mc}--outlined`);
  }
  return cls;
}

export function styleCardHeader(props: CardHeaderProps) {
  const mc = 'CardHeader';
  const cls = {
    main: [mc],
    inner: [`${mc}__Inner`],
    heading: [`${mc}__Heading`],
    subheading: [`${mc}__Subheading`],
    icon: [`${mc}__Icon`],
    actions: [`${mc}__Actions`]
  };
  if (props.disablePadding) {
    cls.main.push(`${mc}--disablePadding`);
  }
  if (props.dim) {
    cls.main.push(`${mc}--dim`);
  }
  return cls;
}

export function styleCardBody(props: CardBodyProps) {
  const mc = 'CardBody';
  const cls = {
    main: [mc]
  };
  if (props.disablePadding) {
    cls.main.push(`${mc}--disablePadding`);
  }
  return cls;
}

export function styleCardFooter(props: CardFooterProps) {
  const mc = 'CardFooter';
  const cls = {
    main: [mc]
  };
  if (props.disablePadding) {
    cls.main.push(`${mc}--disablePadding`);
  }
  if (props.dim) {
    cls.main.push(`${mc}--dim`);
  }
  return cls;
}
